import type { NewAccountDevice } from '@op/services'
import { DeviceType, WEB_PARENT_APP_NAME } from '@op/services'
import moment from 'moment-timezone'
import { browserInfo$, isMobileDevice$, osInfo$ } from '../reducers/browser-info.slice'
import type { RootState } from '../reducers/rootReducer'
import type { OPThunk } from '../types'

export const generateNewAccountDevice = (): OPThunk<NewAccountDevice> => (_, getState) =>
	getNewAccountDevice(getState())

const getNewAccountDevice = (state: RootState): NewAccountDevice => {
	const { name: make = '', version = '' } = browserInfo$(state)
	const { name: os = '', version: os_version = '' } = osInfo$(state)

	return {
		app: WEB_PARENT_APP_NAME,
		app_version: process.env.APP_VERSION,
		make,
		model: `mobile: ${isMobileDevice$(state)}`,
		os,
		os_version,
		time_zone: moment.tz.guess(),
		type: DeviceType.Account,
		version,
	}
}
